import Image from '../Image/Image';
import React from 'react';
import CONFIG from '../../config';

export const poll = (fn: () => boolean, timeout: number, interval: number) => {
  var endTime = Number(new Date()) + (timeout || 2000);
  interval = interval || 100;

  var checkCondition = function(resolve: any, reject: any) {
    // If the condition is met, we're done!
    var result = fn();
    if (result) {
      resolve(result);
    }
    // If the condition isn't met but the timeout hasn't elapsed, go again
    else if (Number(new Date()) < endTime) {
      setTimeout(checkCondition, interval, resolve, reject);
    }
    // Didn't match and too much time, reject!
    else {
      reject(new Error('timed out for ' + fn + ': ' + arguments));
    }
  };

  return new Promise<boolean>(checkCondition);
};

export function timeout(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}


//Redirects user to new page if store and same tab if upc
export function redirectUser(link: string, trackingCode?: string) {
  if(trackingCode)
    adobeTrack(trackingCode)
  if (CONFIG.isUPC) {
    window.location.href = link;
  } else {
    let win = window.open(link, '_blank');
    win.focus();
  }
}

export const getNavigationPageLink = (key: string) => {
  let parsedCountryCode = CONFIG.countryCode === 'uk' ? '' : `${CONFIG.countryCode}/`;
  //Different link for ncsa
  let isDifferentLink =  CONFIG.isUPC && (CONFIG.countryCode === 'us' || CONFIG.countryCode === 'ca');
  const LANDING_PAGE_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus`;
  const GAMES_LINK = `${CONFIG.isUPC ? '/upc' : ''}${CONFIG.countryCode === 'uk' ? '' : `/${CONFIG.countryCode}`}/ubisoftplus/games`;
  const REWARDS_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus${isDifferentLink ? '-' : '/'}rewards`;
  const CLOUD_GAMING_LINK = `/${CONFIG.isUPC ? 'upc/' : ''}${parsedCountryCode}ubisoftplus${isDifferentLink ? '-' : '/'}cloud`;

  switch (key) {
    case 'landing':
      return LANDING_PAGE_LINK;
    case 'games' :
      return GAMES_LINK;
    case 'rewards' :
      return REWARDS_LINK;
    case 'cloud' :
      return CLOUD_GAMING_LINK;
    default:
      break;
  }
};

//Returns Image object used by PictureImage
export const getImage = (imageLink : string, hasTablet :boolean) => {
  let imageJson = [ {
    imageName: imageLink + ((hasTablet)?'_desktop':''),
    minWidth: 751
  }];
  if (hasTablet){
    imageJson.push({
      imageName: imageLink + '_mobile',
      minWidth: 0
    })
  }
  return imageJson
}

import { ReactComponent as FullRewardIcon } from '../../assets/full_reward_icon.svg';
import { ReactComponent as CutRewardIcon } from '../../assets/cut_reward_icon.svg';
//Creates a badge item from the amount of badges needed
export const getGiftBadges : any = (badgeAmount : number) => {
  let imageRefArray = new Array(badgeAmount);
  for(let i = 0; i < badgeAmount; i++){
    imageRefArray[i] = i === 0 ? 'full_reward_icon' : 'cut_reward_icon';
  }
  return imageRefArray.map((imageName : string,index) => {
    let itemClass = '';
    if (index === 0 && imageRefArray.length !== 1){
      itemClass = 'firstGift'
    }else if ( index >= 1 && index!== imageRefArray.length -1){
      itemClass = 'giftIcon';
    }

    return imageName === 'full_reward_icon' ? <FullRewardIcon className={itemClass} key={index}/> : <CutRewardIcon className={itemClass} key={index}/>
  })
}
export const pollConstants = async () => {
  try {
    await poll(
      () => {
        return (window as any).Constants;
      },
      2000,
      150
    );

    return (window as any).Constants;
  } catch (error) {
    return null;
  }
};

export const pollGeoRestrictedResources = async () => {
  try {
    await poll(
      () => {
        return (window as any).GeoRestrictedResources;
      },
      2000,
      150
    );

    return (window as any).GeoRestrictedResources;
  } catch (error) {
    return null;
  }
};

export const getGeoResourcesSettings = async () => {
  const objReady = await pollGeoRestrictedResources();

  if (!objReady) {
    return null;
  }
  return {
    currency: (window as any).GeoRestrictedResources.STOREFRONT_CURRENCY_CODE,
    localeId: (window as any).GeoRestrictedResources.STOREFRONT_CURRENT_LOCALE,
    countryCode: (window as any).GeoRestrictedResources.GEORESTRICTED_CURRENTSITE
  };
};

export const pollWindowVariable = async (
  property: string,
  timeout: number = 2000
) => {
  try {
    const w = window as any;
    await poll(
      () => {
        return w[property];
      },
      timeout,
      150
    );

    return w[property];
  } catch (error) {
    return null;
  }
};

export const pollWindowVariables = (properties: string[]) => {
  const promises = properties.map(property => {
    return new Promise(resolve => resolve(pollWindowVariable(property)));
  });

  return promises;
};

//Tracking utils
export const sendWaData = async () => {
  try {
    const wa_data = await pollWindowVariable('wa_data');
    if (wa_data) {
      setTimeout(() => {
        wa_data.siteSection = 'ubisoft subscription : rewards';
        wa_data.pageName = 'ubisoft plus';
      }, 0);
    }
  } catch (error) {
    console.error(error);
  }
};

/** Tracking function
 *
 * @param action  : tracking action
 * @param customEvent : custom event that isn't clickevent
 */
export function adobeTrack (action: string, customEvent?: string)  {
  try {
    // @ts-ignore
    (window as any).tc_events_100(this, customEvent ? customEvent : 'clickevent', { ACTION: action });
  } catch (e) {
    console.log(e);
  }
};